import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SEARCH_QUERY_DEFAULT } from 'constants/query'
import { ISearchQuery } from 'interfaces'
import {
  IOffsetLimitPage,
  ISearchQueryActionPayload
} from 'interfaces/commons/IOffsetLimitPage'
import { RootState } from 'store'

export interface ISearchQueryState {
  [key: string]: ISearchQuery<any>
}

const initialState: ISearchQueryState = {}

export const querySearchSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setSearchQueryAction: (
      state: ISearchQueryState,
      action: PayloadAction<ISearchQueryActionPayload>
    ) => {
      if (!state[action?.payload?.field as string]) {
        state[action.payload.field as keyof ISearchQueryState] = {
          ...SEARCH_QUERY_DEFAULT,
          ...action.payload.params
        }
        return
      }
      state[action.payload.field as keyof ISearchQueryState] =
        action.payload.params
    },
    setOffsetLimitAction: (
      state: ISearchQueryState,
      action: PayloadAction<IOffsetLimitPage>
    ) => {
      state[action.payload.field as keyof ISearchQueryState] =
        state[action.payload.field as keyof ISearchQueryState] ||
        SEARCH_QUERY_DEFAULT
      state[action.payload.field as keyof ISearchQueryState] = {
        ...state[action.payload.field as keyof ISearchQueryState],
        offset: action.payload.offset
      }
      state[action.payload.field as keyof ISearchQueryState] = {
        ...state[action.payload.field as keyof ISearchQueryState],
        limit: action.payload.limit
      }
    },
    setForceQueryAction: (
      state: ISearchQueryState,
      action: PayloadAction<ISearchQueryActionPayload>
    ) => {
      state[action?.payload?.field as string] = action.payload.params
    },
    resetSearchQueryStateAction: () => initialState
  }
})

export const {
  setSearchQueryAction,
  setOffsetLimitAction,
  setForceQueryAction,
  resetSearchQueryStateAction
} = querySearchSlice.actions
export const querySearchSelector = (state: RootState) =>
  state.searchQueryReducer
export default querySearchSlice.reducer
